import { FormControl, Select, MenuItem, InputLabel, FormHelperText } from "@mui/material"
import { ErrorMessage, useField } from "formik"

const SelectField = ({ options, name, label }) => {
    const [{ value, onChange, onBlur }, { error, touched }, { setValue }] = useField(name);

    return (
        <FormControl fullWidth error={Boolean(touched && error)}>
            <InputLabel id={`${name}-label`}>{label}</InputLabel>
            <Select
                labelId={`${name}-label`}
                id={name}
                label={label}
                value={value || ''}

                onChange={(evt) => {
                    setValue(evt.target.value);
                }}
                onBlur={onBlur}
            >
                {options.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText>
                <ErrorMessage name={name} />
            </FormHelperText>
        </FormControl>
    );
};


export default SelectField